import usersController from './usersController'

export default usersController



// WEBPACK FOOTER //
// ../src/controllers/usersController/index.js